const NotificationTracker = function() {
    return {
        queue: [],
        message: '',
        open: false,
        interval: null,
        type: '',
        stop: false,
        auto_close : true,
        timeLeft: 50,
        handleCloseEvent($event) {
            const $next = this.queue.pop();
            this.open = false;
            setTimeout(() => {
                if ($next) {
                    this.handleOpenEvent($next);
                }

            }, 500)

        },
        handleOpenEvent($event) {
            if (this.open) {
                if (this.message !== $event.detail.message) {
                    this.queue.push($event)
                } else {
                    this.timeLeft = 100;
                }
            } else if ($event.detail) {

                this.message = $event.detail.message
                this.type = $event.detail.type
                this.auto_close = $event.detail.auto_close != null ? $event.detail.auto_close  : true ;
                this.open = true;

                if (this.auto_close) {
                    this.interval = setInterval(() => {
                        if (this.stop) {
                            return;
                        }

                        if (this.timeLeft > 0) {
                            this.timeLeft -= 2;
                        } else {
                            this.handleCloseEvent(null)
                            this.timeLeft = 100;
                            clearInterval(this.interval)
                            this.interval = null;
                        }
                    }, 100)
                }
            }


        },
        getBorderColor() {
            return 'border-gray-200';
        },
        getTextColor() {
            return (this.type === 'success' && 'text-green-500')
                || (this.type === 'error' && 'text-red-500')
                || (this.type === 'warning' && 'text-yellow-500')
                || (this.type === 'info' && 'text-blue-500')
        },
        getBackgroundColor() {
            return (this.type === 'success' && 'bg-green-500')
                || (this.type === 'error' && 'bg-red-500')
                || (this.type === 'warning' && 'bg-yellow-500')
                || (this.type === 'info' && 'bg-blue-500')
        },
        getProgressBarColor() {
            return (this.type === 'success' && 'bg-green-400')
                || (this.type === 'error' && 'bg-red-400')
                || (this.type === 'warning' && 'bg-yellow-400')
                || (this.type === 'info' && 'bg-blue-400')
        },
        getProgressColor() {
            return (this.type === 'success' && 'bg-green-200')
                || (this.type === 'error' && 'bg-red-200')
                || (this.type === 'warning' && 'bg-yellow-200')
                || (this.type === 'info' && 'bg-blue-200')
        }

    }

}
export default NotificationTracker